import { EMPTY_ARRAY } from "config/constants";
import { useDispatch } from "react-redux";
import { getPeriodTypes, updateCustomPeriodTypes } from "store/actions";
import { PeriodType } from "store/types";
import { RootState } from "../reducers";

export const selectPeriodTypesByTeam =
  (teamId: string) =>
  (state: RootState): PeriodType[] =>
    state.periodTypes.teamsById[teamId] ?? EMPTY_ARRAY;

export const usePeriodTypesDispatch = () => {
  const dispatch = useDispatch();
  return {
    getPeriodTypes: (teamId: string, forcedScope?: string) =>
      dispatch(getPeriodTypes(teamId, forcedScope)),
    updateCustomPeriodTypes: (periodTypes: PeriodType[], teamId: string) =>
      dispatch(updateCustomPeriodTypes(periodTypes, teamId)),
  };
};
